@import "../../../globalStyles/commons";

:host {
  display: block;
  width: 100%;
  padding: v(--spacing-02) 0;
}

.divider {
  border-top: 1px solid v(--border-subtle);
}
